import { useField } from "formik";
import { DateValue } from "react-aria-components";

import {
  DateField,
  DateFieldProps,
} from "../components/inputs/date-input/DateField";
import { parseDateFromValue } from "../components/inputs/date-input/utils";

interface Props
  extends Omit<
    DateFieldProps,
    "isInvalid" | "errorMessage" | "onBlur" | "value" | "onChange"
  > {
  name: string;
}

export function DateFieldFormikField(props: Props) {
  const { name, ...dateFieldProps } = props;

  const [field, meta, helpers] = useField(name);

  return (
    <DateField
      name={name}
      isInvalid={Boolean(meta.touched && meta.error)}
      errors={meta.touched ? meta.error : undefined}
      onBlur={() => helpers.setTouched(true)}
      value={parseDateFromValue(field.value) as DateValue | null | undefined}
      onChange={(value: DateValue | null) => {
        setTimeout(() => helpers.setValue(value ? value.toString() : null));
      }}
      {...dateFieldProps}
    />
  );
}
